import Machines_C_0 from './Machines_C/Machines_C_0'
import Machines_C_1 from './Machines_C/Machines_C_1'
import Machines_C_2 from './Machines_C/Machines_C_2'
import Machines_C_3 from './Machines_C/Machines_C_3'
import Machines_C_4 from './Machines_C/Machines_C_4'
import Machines_C_5 from './Machines_C/Machines_C_5'
import Machines_C_6 from './Machines_C/Machines_C_6'
import Machines_C_7 from './Machines_C/Machines_C_7'
import Machines_C_8 from './Machines_C/Machines_C_8'

const Machines_C = [
  Machines_C_0,
  Machines_C_1,
  Machines_C_2,
  Machines_C_3,
  Machines_C_4,
  Machines_C_5,
  Machines_C_6,
  Machines_C_7,
  Machines_C_8,
  null,
  null,
  null
]

export default Machines_C



// WEBPACK FOOTER //
// ./src/components/Machines_C.js